import Header from "../../components/ui/header";
import CollapsibleCard from "../../components/ui/accordion";
import { formatCurrency } from "../../components/ui/money";

type HistoryRecordType = Record<string, Record<string, any>>;

const i18n: Record<string, string> = {
  electricity: "Електроенергія",
  losses: "Нарахування",
  services: "Послуги",
  service_type_of_service_name: "Тип послуги",
  day: "День",
  night: "Ніч",
  year: "Рік",
  once: "Одноразово",
};

const allowedKeys: Record<string, string> = {
  years: "Период",
  // cottage_village: "Коттеджный поселок",
  // personal_account: "Лицевой счет",
  service: "Послуга",
  // apartment: "Квартира",
  // responsible_owner: "Ответственный владелец",
  // initial_balance: "Начальный остаток",
  accrued: "Нараховано",
  paid: "Сплачено",
  // final_balance: "Конечный остаток",
  final_balance: "Борг",
};

const allowedHeadersAmount: Record<string, string> = {
  Expense: 'Сплачено',
  // FinalBalance: 'Залишок',
  // InitialBalance: 'Нараховано',
};

const allowedHeadersHistoryAmount: Record<string, string> = {
  Expense: 'Сплачено',
  // FinalBalance: 'Залишок',
  // InitialBalance: 'Нараховано',
};

// accrued
// address
// final_balance
// initial_balance
// paid
// period
// responsible_owner
// section
// service

const allowedKeysAmount: Record<string, string> = {
  expense: 'Сплачено',
  final_balance: 'Залишок',
  initial_balance: 'Нараховано',
};

type RenderHistoryRecordProps = {
  membership: Record<string, any>;
  history: Record<string, any>;
  account: string;
  includeKeys?: string[];
  excludeKeys?: string[];
};

const RenderMembershipRecord: React.FC<RenderHistoryRecordProps> = (
  {
    membership,
    history,
    account,
    includeKeys = [],
    excludeKeys = [],
  }) => {

  const tI18n = (key: string) => {
    const translation = i18n[key];
    return translation ? translation : key;
  }

  const tAllowedKeys = (key: string) => {
    const translation = allowedKeys[key];
    return translation ? translation : key;
  }

  const tAllowedKeysAmount = (key: string) => {
    const translation = allowedKeysAmount[key];
    return translation ? translation : key;
  }

  const renderHistoryItem = (key: string) => {
    // Check if includeKeys is empty and excludeKeys does not contain the key
    if (includeKeys.length === 0 && !excludeKeys.includes(key)) {
      return true; // Render the item
    }
    // If it's in includeKeys and not in excludeKeys, render the item
    if (includeKeys.includes(key) && !excludeKeys.includes(key)) {
      return true; // Render the item
    }
    // If it's in excludeKeys, do not render the item
    if (excludeKeys.includes(key)) {
      return false; // Do not render the item
    }
    return false; // Default case if none of the conditions are met
  };

  return (
    <div
      key={`title-${account}-${Math.random()}`}
      className="bg-white mb-4"
    >
      <div>
        <div className="text-sm overflow-x-auto">
          <table className="table-auto w-full">
            <thead>
            <tr>
              {Object.entries(allowedKeys)?.map(([key, translate]: [string, any]) => {
                if (key === "amount") {
                  return Object.entries(allowedHeadersAmount)?.map(([keyA, translateA]: [string, any]) => {
                    return (
                      <th className="text-red-700"
                          key={`${membership?.[0]?.["dateTime"]}-${key}-${keyA}`}>
                        {tAllowedKeys(key)} {translateA}
                      </th>
                    )
                  })
                }
                return (
                  <th className="border border-gray-200 text-red-700"
                      key={`${membership?.[0]?.["dateTime"]}-${key}`}>{translate}</th>
                )
              })}
            </tr>
            </thead>
            <tbody className={"text-sm text-gray-900"}>
            {Object.entries(membership || {})?.reverse()?.map(([year, entries]: [string, any]) => {
              return Object.entries(entries)?.map(([no, entry]: [string, any]) => {
                const serviceName = entry["service"] || "Unknown Service";
                return (
                  <tr key={`tr-${serviceName}`}>
                    {
                      Object.entries(allowedKeys)?.map(([key, translate]: [string, any]) => {
                        if (!renderHistoryItem(entry["service"])) return null;
                        if (key === "amount") {
                          return Object.entries(allowedHeadersAmount)?.map(([keyA, translateA]: [string, any]) => {
                            return (
                              <td className="border border-gray-200 text-left p-2"
                                  key={`${serviceName}-${key}-${keyA}`}>
                                {formatCurrency(entry[key][keyA] ? entry[key][keyA] : "0.0")}
                              </td>
                            )
                          })
                        }
                        if (key === "years") {
                          return (
                            <td className="border border-gray-200 text-left p-2"
                                key={`${serviceName}-${key}-years`}>
                              {Object.keys(entry?.[key] || {}).map((year: string, index: number) => (
                                <span key={`${serviceName}-${key}-year-${year}`}>
                                  {year}{" "}{index > 0 ? (<br/>) : ""}
                                </span>
                              ))}
                            </td>
                          )
                        }
                        if (key === "accrued" && entry[key] === "") {
                          key = "initial_balance"; // Fallback to initial_balance if accrued is not available
                        }
                        const amount = Number(entry[key]?.toString().replace(/,/g, '')) || 0;
                        if (key === "accrued" || key === "initial_balance" || key === "final_balance" || key === "paid") {
                          const formatCurrency1 = formatCurrency(amount);
                          return ((entry[key] && !isNaN(amount)) ?
                              (<td className="border border-gray-200 text-left p-2"
                                   key={`${serviceName}-${key}`}>{formatCurrency1}</td>) :
                              (<td className="border border-gray-200 text-center p-2"
                                   key={`${serviceName}-${key}`}>{"-"}</td>)
                          )
                        }
                        return (entry[key] ?
                            (<td className="border border-gray-200 text-left p-2"
                                 key={`${serviceName}-${key}`}>{tI18n(entry[key]?.toString())}</td>) :
                            (<td className="border border-gray-200 text-center p-2"
                                 key={`${serviceName}-${key}`}>{"-"}</td>)
                        )
                      })
                    }
                  </tr>
                )
              })
            })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
};

export const MembershipViewer = (
  {
    membership,
    history,
    account,
    openState = false,
    title = "",
    includeKeys = [],
    excludeKeys = []
  }: {
    membership: HistoryRecordType
    history: HistoryRecordType
    account: string
    title?: string
    includeKeys?: string[];
    excludeKeys?: string[];
    openState?: boolean
    className?: string
  }) => {
  return (
    <Header className={"border rounded-lg"} key={`header-${account || ''}`}>
      <CollapsibleCard title={title || ''} open={openState || false} className="grid grid-cols-1 divide-y" more={false}>
        <RenderMembershipRecord
          key={`RenderRecord-${account}`}
          membership={membership}
          history={history}
          account={account}
          includeKeys={includeKeys}
          excludeKeys={excludeKeys}
        />
      </CollapsibleCard>
    </Header>
  );
};
